import { render, staticRenderFns } from "./botts.vue?vue&type=template&id=3e445130&scoped=true&"
import script from "./botts.vue?vue&type=script&lang=js&"
export * from "./botts.vue?vue&type=script&lang=js&"
import style0 from "./botts.vue?vue&type=style&index=0&id=3e445130&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e445130",
  null
  
)

export default component.exports